import { render, staticRenderFns } from "./close-button.vue?vue&type=template&id=a383ec5a&lang=html&"
import script from "./close-button.vue?vue&type=script&lang=js&"
export * from "./close-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Devdoc\\_packages\\moss-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a383ec5a')) {
      api.createRecord('a383ec5a', component.options)
    } else {
      api.reload('a383ec5a', component.options)
    }
    module.hot.accept("./close-button.vue?vue&type=template&id=a383ec5a&lang=html&", function () {
      api.rerender('a383ec5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/close-button.vue"
export default component.exports